/**
 *
 * TRANSITION CUSTOM ELEMENT
 * Handles in fade in and out of child elements inside the x-transition element.
 *
 * For Reference see /sections/announcement-bar.liquid for setup
 *
 * For set up:
 * 1. Wrap your elements you wish to view inside the x-transition element.
 * 2. Make sure each element is relative to the x-transition and full width.
 * 3. Optional the default interval time is 5000 if you want change this you can update the x-transition
 * data-timeout value on the element itself.
 *
 */
class TransitionElement extends HTMLElement {
  static CHILD_SELECTOR = '[data-role="child"]'
  constructor() {
    super()
    this.timeout = this.dataset?.timeout || 5000
    this.current = 0
  }

  fetchChildren() {
    this.announcementChildren = this.querySelectorAll(TransitionElement.CHILD_SELECTOR)
  }

  intervalCallback() {
    this.announcementChildren[this.current].classList.add('opacity-0', 'pointer-events-none')
    this._handleNextChild()
    this.announcementChildren[this.current].classList.remove('opacity-0', 'pointer-events-none')
  }

  _handleNextChild() {
    const total = this.announcementChildren.length
    if (this.current + 1 >= total) {
      this.current = 0
      return
    }
    this.current += 1
  }

  removeIntervalCallback() {
    clearInterval(this.intervalFunction)
  }

  setIntervalCallback() {
    /** Check and see if there are any children if not do not set the interval. */
    if (!this.announcementChildren.length) return
    this.intervalFunction = setInterval(this.intervalCallback.bind(this), this.timeout)
  }

  connectedCallback() {
    this.fetchChildren()
    this.setIntervalCallback()
  }

  disconnectedCallback() {
    this.removeEventListeners()
  }
}

customElements.define('x-transition', TransitionElement)
